import * as React from 'react';
import signImg from '../images/specimen.png';

class ImgTooltipTemplate extends React.Component {
  
    render() {
        return (
            <div>
                <p className="tooltip-p-txt">{this.props.desc}</p>
                <img src={signImg} alt="" className="tooltip-img" />
                <br/>
            </div>
        )
    }
}

export default ImgTooltipTemplate;